$(function () {
    var $rightFixed = $('#js-right-fixed');
    if ($rightFixed.length < 1 || window.UA.isSP === true) {
        return;
    }
    $(window).on('imageloaded', function(){
        var offsetTop = $rightFixed.offset().top + 50;
        var offsetFooter = getOffetFooter();
        if ($('.content-letters-detail-main').height() >  $rightFixed.height()) {
            $(window).on('scroll', function () {
                if($(window).width() < 781){
                    $rightFixed.css({'position': 'static', 'top': 'auto'});
                }else{
                    side($rightFixed, offsetTop, offsetFooter);
                }
            });
            $(window).on('resize', function () {
                //left = getLeft();
                offsetFooter = getOffetFooter();
                $(window).trigger('scroll');
            });
        }
    });
    function getLeft() {
        return $rightFixed.offset().left;
    }

    function getOffetFooter() {
        return $('.l-footer').offset().top;
    }

    function side($elm, h, end) {
        var scrollPos = $(window).scrollTop(),
            endPos = end - $elm.height()-245;

        //console.log(scrollPos, h, end, endPos, left);
        if (scrollPos >= h - 50 && scrollPos <= endPos) {
            $elm.css({'position': 'fixed', 'top': 0});
        } else if (scrollPos < h) {
            $elm.css({'position': 'absolute', 'top': 0});
        } else if (scrollPos > endPos) {
            $elm.css({'position': 'absolute', 'top': endPos-365});
        }
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/pc/js/module/fixedScroll.js
 ** module id = 3
 ** module chunks = 2
 **/